import orclient from '../../submodules/c3po-client-js';
import config from './Config';

const { apiBase, log } = config;

export const base = (window && window.windowAPIBase) ? window.windowAPIBase : apiBase;

export const apiClient = (new orclient({server: base, debug: log.client, useAgent: true }));
